import React, { useEffect, useRef } from 'react';

const BackgroundGraph = () => {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;

    const dataPoints: number[] = [];
    const numPoints = 50;
    
    // Generate random data points
    for (let i = 0; i < numPoints; i++) {
      dataPoints.push(Math.random() * 100 + 50);
    }

    let animationOffset = 0;

    const drawGraph = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      // Draw grid lines
      ctx.strokeStyle = 'rgba(34, 197, 94, 0.05)';
      ctx.lineWidth = 1;
      
      // Horizontal grid lines
      for (let i = 0; i < 10; i++) {
        const y = (canvas.height / 10) * i;
        ctx.beginPath();
        ctx.moveTo(0, y);
        ctx.lineTo(canvas.width, y);
        ctx.stroke();
      }
      
      // Vertical grid lines
      for (let i = 0; i < 20; i++) {
        const x = (canvas.width / 20) * i;
        ctx.beginPath();
        ctx.moveTo(x, 0);
        ctx.lineTo(x, canvas.height);
        ctx.stroke();
      }

      // Draw the main graph line
      ctx.strokeStyle = 'rgba(34, 197, 94, 0.3)';
      ctx.lineWidth = 2;
      ctx.beginPath();

      const stepX = canvas.width / (numPoints - 1);
      
      for (let i = 0; i < numPoints; i++) {
        const x = i * stepX;
        const animatedValue = dataPoints[i] + Math.sin(animationOffset + i * 0.1) * 10;
        const y = canvas.height - (animatedValue * 2);
        
        if (i === 0) {
          ctx.moveTo(x, y);
        } else {
          ctx.lineTo(x, y);
        }
      }
      
      ctx.stroke();

      // Draw area under the curve
      ctx.fillStyle = 'rgba(34, 197, 94, 0.05)';
      ctx.beginPath();
      
      for (let i = 0; i < numPoints; i++) {
        const x = i * stepX;
        const animatedValue = dataPoints[i] + Math.sin(animationOffset + i * 0.1) * 10;
        const y = canvas.height - (animatedValue * 2);
        
        if (i === 0) {
          ctx.moveTo(x, canvas.height);
          ctx.lineTo(x, y);
        } else {
          ctx.lineTo(x, y);
        }
      }
      
      ctx.lineTo(canvas.width, canvas.height);
      ctx.closePath();
      ctx.fill();

      // Draw glowing dots at data points
      for (let i = 0; i < numPoints; i += 3) {
        const x = i * stepX;
        const animatedValue = dataPoints[i] + Math.sin(animationOffset + i * 0.1) * 10;
        const y = canvas.height - (animatedValue * 2);
        
        // Glow effect
        const gradient = ctx.createRadialGradient(x, y, 0, x, y, 8);
        gradient.addColorStop(0, 'rgba(34, 197, 94, 0.8)');
        gradient.addColorStop(1, 'rgba(34, 197, 94, 0)');
        
        ctx.fillStyle = gradient;
        ctx.beginPath();
        ctx.arc(x, y, 8, 0, Math.PI * 2);
        ctx.fill();
        
        // Center dot
        ctx.fillStyle = 'rgba(34, 197, 94, 1)';
        ctx.beginPath();
        ctx.arc(x, y, 2, 0, Math.PI * 2);
        ctx.fill();
      }

      // Draw moving vertical line (scanner effect)
      const scannerX = (animationOffset * 50) % canvas.width;
      const gradient2 = ctx.createLinearGradient(scannerX - 50, 0, scannerX + 50, 0);
      gradient2.addColorStop(0, 'rgba(34, 197, 94, 0)');
      gradient2.addColorStop(0.5, 'rgba(34, 197, 94, 0.2)');
      gradient2.addColorStop(1, 'rgba(34, 197, 94, 0)');
      
      ctx.fillStyle = gradient2;
      ctx.fillRect(scannerX - 50, 0, 100, canvas.height);

      animationOffset += 0.02;
      requestAnimationFrame(drawGraph);
    };

    drawGraph();

    const handleResize = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <canvas
      ref={canvasRef}
      className="absolute inset-0 pointer-events-none z-0"
      style={{ opacity: 0.4 }}
    />
  );
};

export default BackgroundGraph;
